import { ConvertableFromApi } from "./ConvertableFromApi";

export class Template extends ConvertableFromApi<Template> {
  public name!: string;
  public filename!: string;
  public estimatedCost!: Number;
  public templateSpecificParameters!: TemplateParameter[];

  constructor(data?: any) {
    super(data);
    if (!this.objectFromApi) {
      return;
    }

    this.name = this.objectFromApi.name;
    this.filename = this.objectFromApi.filename;
    this.estimatedCost = this.objectFromApi.estimatedCostsPerMonthInEuro;
    this.templateSpecificParameters = [];
    var parameters: TemplateParameter[] = [];
    this.objectFromApi.templateSpecificParameters.forEach((parameterFromApi: any) => {
      if (parameterFromApi.showInForm) {
        var parameter = new TemplateParameter();
        parameter.name = parameterFromApi.name;
        parameter.type = parameterFromApi.type;
        parameter.default = parameterFromApi.default;
        parameters.push(parameter);
      }
    });
    this.templateSpecificParameters = parameters;
  }

  public createNew(element: any): Template {
    return new Template(element);
  }
}

export class TemplateParameter {
  public name: string;
  public type: string;
  public default: string;
}